import styled from 'styled-components';
import Svg from 'components/SVG';

export const TwitterSvg = () => (
  <TwitterStyled viewBox="0 0 455.731 455.731">
    <g>
      <path
        d="M60.377,337.822c30.33,19.236,66.308,30.368,104.875,30.368c108.349,0,196.18-87.841,196.18-196.18
c0-2.705-0.057-5.39-0.161-8.067c3.919-3.084,28.157-22.511,34.098-35c0,0-19.683,8.18-38.947,10.107
c-0.038,0-0.085,0.009-0.123,0.009c0,0,0.038-0.019,0.104-0.066c1.775-1.186,26.591-18.079,29.951-38.207
c0,0-13.922,7.431-33.415,13.932c-3.227,1.072-6.605,2.126-10.088,3.103c-12.565-13.41-30.425-21.78-50.25-21.78
c-38.027,0-68.841,30.805-68.841,68.803c0,5.362,0.617,10.581,1.784,15.592c-5.314-0.218-86.237-4.755-141.289-71.423
c0,0-32.902,44.917,19.607,91.105c0,0-15.962-0.636-29.733-8.864c0,0-5.058,54.416,54.407,68.329c0,0-11.701,4.432-30.368,1.272
c0,0,10.439,43.968,63.271,48.077c0,0-41.777,37.74-101.081,28.885L60.377,337.822z"
      />
    </g>
  </TwitterStyled>
);

export const DiscordSvg = () => (
  <DiscordStyled viewBox="0 -28.5 256 256">
    <g>
      <path d="M216.856339,16.5966031 C200.285002,8.84328665 182.566144,3.2084988 164.041564,0 C161.766523,4.11318106 159.108624,9.64549908 157.276099,14.0464379 C137.583995,11.0849896 118.072967,11.0849896 98.7430163,14.0464379 C96.9108417,9.64549908 94.1925838,4.11318106 91.8971895,0 C73.3526068,3.2084988 55.6133949,8.86399117 39.0420583,16.6376612 C5.61752293,67.146514 -3.4433191,116.400813 1.08711069,164.955721 C23.2560196,181.510915 44.7403634,191.567697 65.8621325,198.148576 C71.0772151,190.971126 75.7283628,183.341335 79.7352139,175.300261 C72.104019,172.400575 64.7949724,168.822202 57.8887866,164.667963 C59.7209612,163.310589 61.5131304,161.891452 63.2445898,160.431257 C105.36741,180.133187 151.134928,180.133187 192.754523,160.431257 C194.506336,161.891452 196.298154,163.310589 198.110326,164.667963 C191.183787,168.842556 183.854737,172.420929 176.223542,175.320965 C180.230393,183.341335 184.861538,190.991831 190.096624,198.16893 C211.238746,191.588051 232.743023,181.531619 254.911949,164.955721 C260.227747,108.668201 245.831087,59.8662432 216.856339,16.5966031 Z M85.4738752,135.09489 C72.8290281,135.09489 62.4592217,123.290155 62.4592217,108.914901 C62.4592217,94.5396472 72.607595,82.7145587 85.4738752,82.7145587 C98.3405064,82.7145587 108.709962,94.5189427 108.488529,108.914901 C108.508531,123.290155 98.3405064,135.09489 85.4738752,135.09489 Z M170.525237,135.09489 C157.88039,135.09489 147.510584,123.290155 147.510584,108.914901 C147.510584,94.5396472 157.658606,82.7145587 170.525237,82.7145587 C183.391518,82.7145587 193.761324,94.5189427 193.539891,108.914901 C193.539891,123.290155 183.391518,135.09489 170.525237,135.09489 Z"></path>
    </g>
  </DiscordStyled>
);

export const OpenSeaSvg = () => (
  <OpenSea viewBox="0 0 90 90">
    <path d="M22.2011 46.512L22.3953 46.2069L34.1016 27.8939C34.2726 27.6257 34.6749 27.6535 34.8043 27.9447C36.76 32.3277 38.4475 37.7786 37.6569 41.1721C37.3194 42.5683 36.3948 44.4593 35.3545 46.2069C35.2204 46.4612 35.0725 46.7109 34.9153 46.9513C34.8413 47.0622 34.7165 47.127 34.5824 47.127H22.5432C22.2196 47.127 22.0301 46.7756 22.2011 46.512Z" />
    <path d="M74.38 49.9149V52.8137C74.38 52.9801 74.2783 53.1281 74.1304 53.1928C73.2242 53.5812 70.1219 55.0052 68.832 56.799C65.5402 61.3807 63.0251 67.932 57.4031 67.932H33.949C25.6362 67.932 18.9 61.1727 18.9 52.8322V52.564C18.9 52.3421 19.0803 52.1618 19.3023 52.1618H32.377C32.6359 52.1618 32.8255 52.4022 32.8024 52.6565C32.7099 53.5072 32.8671 54.3764 33.2693 55.167C34.0461 56.7435 35.655 57.7283 37.3934 57.7283H43.866V52.675H37.4673C37.1391 52.675 36.9449 52.2959 37.1345 52.0277C37.2038 51.9214 37.2824 51.8104 37.3656 51.6856C37.9713 50.8257 38.8358 49.4895 39.6958 47.9684C40.2829 46.9421 40.8516 45.8463 41.3093 44.746C41.4018 44.5472 41.4758 44.3438 41.5497 44.1449C41.6746 43.7936 41.804 43.4653 41.8965 43.1371C41.9889 42.8597 42.0629 42.5684 42.1369 42.2956C42.3542 41.3617 42.4467 40.3723 42.4467 39.3459C42.4467 38.9437 42.4282 38.523 42.3912 38.1207C42.3727 37.6815 42.3172 37.2423 42.2617 36.8031C42.2247 36.4147 42.1554 36.031 42.0814 35.6288C41.9889 35.0416 41.8595 34.4591 41.7115 33.8719L41.6607 33.65C41.5497 33.2478 41.4573 32.864 41.3278 32.4618C40.9626 31.1996 40.5418 29.9698 40.098 28.8186C39.9362 28.3609 39.7512 27.9217 39.5663 27.4825C39.2935 26.8213 39.0161 26.2203 38.7619 25.6516C38.6324 25.3927 38.5214 25.1569 38.4105 24.9165C38.2857 24.6437 38.1562 24.371 38.0268 24.112C37.9343 23.9132 37.8279 23.7283 37.754 23.5434L36.9634 22.0824C36.8524 21.8836 37.0374 21.6478 37.2546 21.7079L42.2016 23.0487H42.2155C42.2247 23.0487 42.2294 23.0533 42.234 23.0533L42.8859 23.2336L43.6025 23.437L43.866 23.511V20.5706C43.866 19.1512 45.0034 18 46.4089 18C47.1116 18 47.7496 18.2866 48.2073 18.7536C48.665 19.2206 48.9517 19.8586 48.9517 20.5706V24.935L49.4787 25.0829C49.5204 25.0968 49.562 25.1153 49.599 25.143C49.7284 25.2401 49.9133 25.3835 50.1491 25.5591C50.3341 25.7071 50.5329 25.8874 50.7733 26.0723C51.2495 26.4561 51.8181 26.9508 52.4423 27.5194C52.6087 27.6628 52.7706 27.8107 52.9185 27.9587C53.723 28.7076 54.6245 29.5861 55.4845 30.557C55.7249 30.8297 55.9607 31.1071 56.2011 31.3984C56.4415 31.6943 56.6958 31.9856 56.9177 32.2769C57.209 32.6652 57.5233 33.0674 57.7961 33.4882C57.9256 33.687 58.0735 33.8904 58.1984 34.0892C58.5497 34.6209 58.8595 35.1711 59.1554 35.7212C59.2802 35.9755 59.4097 36.2529 59.5206 36.5257C59.8489 37.2608 60.1078 38.0098 60.2742 38.7588C60.3251 38.9206 60.3621 39.0963 60.3806 39.2535V39.2904C60.436 39.5124 60.4545 39.7482 60.473 39.9886C60.547 40.756 60.51 41.5235 60.3436 42.2956C60.2742 42.6239 60.1818 42.9336 60.0708 43.2619C59.9598 43.5763 59.8489 43.9045 59.7056 44.2143C59.4282 44.8569 59.0999 45.4996 58.7115 46.1006C58.5867 46.3225 58.4388 46.5583 58.2908 46.7802C58.129 47.016 57.9626 47.238 57.8146 47.4553C57.6112 47.7327 57.3939 48.0239 57.172 48.2828C56.9732 48.5556 56.7697 48.8284 56.5478 49.0688C56.2381 49.434 55.9422 49.7808 55.6324 50.1137C55.4475 50.331 55.2487 50.5529 55.0452 50.7517C54.8464 50.9736 54.643 51.1724 54.4581 51.3573C54.1483 51.6671 53.8894 51.9075 53.6721 52.1063L53.1635 52.5733C53.0896 52.638 52.9925 52.675 52.8908 52.675H48.9517V57.7283H53.9079C55.0175 57.7283 56.0716 57.3353 56.9223 56.6141C57.2136 56.3598 58.485 55.2594 59.9876 53.5997C60.0384 53.5442 60.1032 53.5026 60.1771 53.4841L73.8668 49.5265C74.1211 49.4525 74.38 49.6467 74.38 49.9149Z" />
  </OpenSea>
);

export const FiroLogoSvg = () => (
  <FiroLogo viewBox="0 0 100 100">
    {/* <g>
      <FiroCirclePath cx="49.76" cy="49.57" r="46" />
    </g> */}
    <g>
      <FiroRedPath
        d="M30.29,70.25c1.09,0,2.12-0.61,2.61-1.58l6.94-13.19H29.11c-1.64,0-2.94-1.33-2.94-2.94v-5.91
		c0-1.64,1.33-2.94,2.94-2.94h16.98L59.28,18.7c0.52-0.97,1.52-1.58,2.61-1.58h22.22C75.5,8.03,63.34,2.36,49.82,2.36
		C23.75,2.36,2.58,23.5,2.58,49.6c0,7.4,1.7,14.43,4.76,20.68h22.95L30.29,70.25L30.29,70.25z"
      />
      <FiroRedPath
        d="M69.29,28.89c-1.09,0-2.12,0.61-2.61,1.58l-6.94,13.19h10.73c1.64,0,2.94,1.33,2.94,2.94v5.91
		c0,1.64-1.33,2.94-2.94,2.94H53.49L40.3,80.44c-0.52,0.97-1.52,1.58-2.61,1.58H15.47c8.61,9.1,20.77,14.77,34.29,14.77
		C75.83,96.78,97,75.64,97,49.54c0-7.4-1.7-14.43-4.76-20.68H69.29L69.29,28.89L69.29,28.89z"
      />
    </g>
  </FiroLogo>
);

export const FiroLogoFullSvg = () => (
  <FiroLogoFull viewBox="0 0 996 424">
    <g>
      <g>
        <FiroWhitePathFull
          className="st0"
          d="M479.8,200.9h-30.7v-33.4h30.7V153c0-56,16.3-58.2,81-58.2v30.3c-35,0-39.4,1.9-39.4,21v21.3h39.4v33.4h-39.4
			V327h-41.6L479.8,200.9L479.8,200.9z M590.3,94.4h42.9v36.9h-42.9V94.4z M590.6,167.4h41.9V327h-41.9V167.4z"
        />
        <FiroWhitePathFull
          className="st0"
          d="M676.4,167.4h39.1l1.2,27.6h2.5c8.5-23.7,25.4-30.1,51.1-30.1v39.8c-41,0-52.3,15-52.3,58.5V327h-41.6
			L676.4,167.4L676.4,167.4z"
        />
        <FiroWhitePathFull
          className="st0"
          d="M792.5,246.9c0-64.5,4.1-82,73.2-82s73.2,17.5,73.2,82s-4.1,82.6-73.2,82.6
			C796.6,329.6,792.5,311.3,792.5,246.9z M897,246.9c0-43.9,0-48.5-31.3-48.5s-31.3,4.7-31.3,48.5s0,49.1,31.3,49.1
			S897,290.7,897,246.9z"
        />
      </g>
      {/* <g>
        <FiroCirclePath className="st1" cx="212.7" cy="212" r="155.4" />
        <FiroCirclePath className="st1" cx="212.7" cy="212" r="149" />
      </g> */}
      <g>
        <FiroRedPathFull
          className="st2"
          d="M148.5,280.2c3.6,0,7-2,8.6-5.2l22.9-43.5h-35.4c-5.4,0-9.7-4.4-9.7-9.7v-19.5c0-5.4,4.4-9.7,9.7-9.7h56
			l43.5-82.4c1.7-3.2,5-5.2,8.6-5.2H326c-28.4-30-68.5-48.7-113.1-48.7c-86,0-155.8,69.7-155.8,155.8c0,24.4,5.6,47.6,15.7,68.2
			h75.7V280.2z"
        />
        <FiroRedPathFull
          className="st2"
          d="M277.1,143.8c-3.6,0-7,2-8.6,5.2l-22.9,43.5h35.4c5.4,0,9.7,4.4,9.7,9.7v19.5c0,5.4-4.4,9.7-9.7,9.7h-56
			l-43.5,82.4c-1.7,3.2-5,5.2-8.6,5.2H99.6c28.4,30,68.5,48.7,113.1,48.7c86,0,155.8-69.7,155.8-155.8c0-24.4-5.6-47.6-15.7-68.2
			h-75.7V143.8z"
        />
      </g>
    </g>
  </FiroLogoFull>
);
//#F3BA2F binance

export const BinanceSvg = () => <Binance viewBox="0 0 800 800">
  <g clip-path="url(#clip1_569_2)">
    {/* <path d="M0 0H800V800H0V0Z" fill="black" /> */}
    <path d="M450.201 565.199V621.27L398.769 650L348.799 621.27V565.199L398.769 593.93L450.201 565.199ZM175 371.27L224.97 400V496.154L311.016 545.042V601.112L175 524.884V371.27V371.27ZM622.537 371.27V525.116L485.059 601.344V545.273L571.105 496.385V400.232L622.537 371.27ZM484.815 295.042L536.248 323.772V379.842L450.201 428.73V526.274L400.231 555.005L350.505 526.274V428.499L261.29 379.611V323.54L312.723 294.81L398.769 343.698L484.815 295.042ZM261.29 419.926L311.26 448.656V504.727L261.29 475.996V419.926ZM536.248 419.926V475.996L486.277 504.727V448.656L536.248 419.926ZM224.97 246.154L276.403 274.884L224.97 303.614V359.685L175 330.955V274.884L224.97 246.154ZM572.567 246.154L624 274.884V330.955L572.567 359.685V303.614L522.597 274.884L572.567 246.154ZM398.769 246.154L450.201 274.884L398.769 303.614L348.799 274.884L398.769 246.154ZM398.769 150L536.248 226.228L486.277 254.958L400.231 206.07L312.479 254.958L262.509 226.228L398.769 150Z" fill="#fff" />
  </g>
  <defs>
    <clipPath id="clip0_569_2">
      <rect width="800" height="800" fill="white" />
    </clipPath>
    <clipPath id="clip1_569_2">
      <rect width="800" height="800" fill="white" />
    </clipPath>
  </defs>
</Binance>


export const MetaMaskSvg = () => <MetaMask viewBox="0 0 50 50">
  <polyline points="29.52,9.61 19.63,9.61 7.41,5.83 20.18,16.72 16.63,21.5 6.85,24.48 4.46,33.06 6.68,42.11 
	15.68,39.44 20.96,43.06 28.41,43.06 "/>
  <polyline points="5.74,4.83 4.02,11.61 6.85,24.48 " />
  <polyline points="4.46,33.06 16.57,33.06 15.68,39.44 " />
  <polygon class="st2" points="18.7,29.32 21.02,29.89 19.86,28.5 " />
  <polyline points="29.38,9.61 41.6,5.83 28.83,16.72 32.38,21.5 42.16,24.48 44.55,33.06 42.33,42.11 33.33,39.44 
	28.05,43.06 "/>
  <polyline points="43.37,4.83 45.09,11.61 42.26,24.48 " />
  <polyline points="44.55,33.06 32.44,33.06 33.33,39.44 " />
  <polygon points="30.46,29.28 27.99,29.89 29.23,28.41 " />
  <polygon points="27.06,36.25 27.06,38.89 22.06,38.89 22.06,36.25 22.9,35.48 26.06,35.48 " />
</MetaMask>

const MetaMask = styled(Svg)`
  width: 100%;
  height: 100%;
  stroke-width: 1.5px;
  polygon {
    stroke: #fff;
  }
  polyline {
    stroke: #fff;
  }
`

const Binance = styled(Svg)`
  width: 90px;
  height: 90px;
`

const FiroLogoFull = styled(Svg)`
  width: 100px;
  cursor: pointer;
`;

const FiroLogo = styled(Svg)`
  width: 120px;
`;

const FiroWhitePathFull = styled.path`
  fill: #fff;
`;

const FiroRedPathFull = styled.path`
  fill: #9b1c2e;
`;

const FiroRedPath = styled.path`
  fill: #9b1c2e;
`;

const TwitterStyled = styled(Svg)`
  width: 32px;
  fill: var(--nav-color);
`;

const DiscordStyled = styled(Svg)`
  width: 26px;
  fill: var(--nav-color);
`;

const OpenSea = styled(Svg)`
  width: 40px;
  fill: var(--nav-color);
`;
